import "./AboutUsModal.css";

import React from "react";
import { useState } from "react";

import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import coffeeVideoPlaceholder from "../../shared/imageAssets/logo.png";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const AboutUsModal = ({ changeNavBar }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div className="modal-button-containerr">
      <div onClick={handleOpen} className="modal-button-container">
        <img
          className="modal-button-ImagePlaceholder"
          src={coffeeVideoPlaceholder}
        ></img>
        <div className="mobal-play-button">
          <PlayArrowIcon sx={{ fontSize: "35px" }} />
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <iframe
            width="100%"
            height="480"
            src="https://www.youtube.com/embed/kdZEzh9y_nM"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* <video controls width="100%">
            <source
              src="https://firebasestorage.googleapis.com/v0/b/viko-admin-07.appspot.com/o/video.mp4?alt=media&token=c2418c58-69e9-4268-b105-09b5539ef46b"
              type="video/mp4"
            />
          </video> */}
        </Box>
      </Modal>
    </div>
  );
};
